import { fetchConToken } from '../helpers/fetch';
import { refreshUsuario } from './usuarios';

export const types = {
    ventaAdded: '[Venta] Added',
};

export const addVenta = (venta) => ({
    type: types.ventaAdded,
    payload: venta
});

export const startSaveVenta = (ventaData) => {
    return async (dispatch, getState) => {
        try {
            const resp = await fetchConToken('ventas', ventaData, 'POST');
            const body = await resp.json();

            if (!body.ok) {
                throw new Error(body.msg);
            }

            if (ventaData.metodoPago === 'Monedero') {
                const respUsuario = await fetchConToken(`usuarios/usuario`, { usuario: ventaData.usuario, empresa: ventaData.empresa }, 'POST');
                const bodyUsuario = await respUsuario.json();
                if (bodyUsuario.usuario) {
                    dispatch(refreshUsuario(ventaData.usuario, bodyUsuario.usuario));
                }
            }

            return { ok: true, venta: body.venta, ...(body.cita && { cita: body.cita }) };
        } catch (error) {
            console.error('Error al guardar la venta:', error);
            return { ok: false, error };
        }
    }
};

export const startSaveVentaMultipago = (ventaData) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('ventas/multipago', ventaData, 'POST');
            const body = await resp.json();

            if (!body.ok) {
                return { ok: false, msg: body.msg };
            }

            const tieneMonedero = (ventaData.pagos || []).some(p => p.metodo === 'Monedero');
            if (tieneMonedero) {
                const respUsuario = await fetchConToken(`usuarios/usuario`, { usuario: ventaData.usuario, empresa: ventaData.empresa }, 'POST');
                const bodyUsuario = await respUsuario.json();
                if (bodyUsuario.usuario) {
                    dispatch(refreshUsuario(ventaData.usuario, bodyUsuario.usuario));
                }
            }

            return { ok: true, ventas: body.ventas, ...(body.cita && { cita: body.cita }) };
        } catch (error) {
            console.error('Error al guardar la venta multipago:', error);
            return { ok: false, msg: 'Error al guardar la venta' };
        }
    };
};

export const startObtenerVentasCita = (citaId) => {
    return async () => {
        try {
            const resp = await fetchConToken(`ventas/cita/${citaId}`);
            const body = await resp.json();
            return body;
        } catch (error) {
            console.error('Error al obtener las ventas de la cita:', error);
            return { ok: false, msg: 'Error al obtener las ventas de la cita' };
        }
    };
};

/**
 * Una venta concreta, poblada (usuario, profesional, sucursal, empresa, cita). La usa el modal
 * de ventas para repoblar el formulario y el cobro con datáfono para resolver el desenlace de
 * `tipoPayload: 'actualizacion'`, donde el backend solo devuelve el id de la venta completada.
 */
export const startObtenerVenta = (ventaId) => {
    return async () => {
        try {
            const resp = await fetchConToken(`ventas/${ventaId}`);
            const body = await resp.json();
            return body;
        } catch (error) {
            console.error('Error al obtener la venta:', error);
            return { ok: false, msg: 'Error al obtener la venta' };
        }
    };
};

export const startEnviarTicketVenta = (citaId) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`ventas/enviar-ticket-cita/${citaId}`, {}, 'POST');
            const body = await resp.json();
            return body;
        } catch (error) {
            console.log(error);
            return { ok: false, msg: 'Error al enviar el ticket' };
        }
    }
}

export const startAnularVenta = (ventaId, { reembolsarMonedero = false } = {}) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`ventas/${ventaId}/anular`, { reembolsarMonedero }, 'POST');
            const body = await resp.json();

            if (!body.ok) {
                return { ok: false, msg: body.msg };
            }

            if (body.usuario) {
                const usuarioId = body.usuario._id;
                if (usuarioId) {
                    dispatch(refreshUsuario(usuarioId, body.usuario));
                }
            }

            return { ok: true, venta: body.venta, usuario: body.usuario };
        } catch (error) {
            console.error('Error al anular la venta:', error);
            return { ok: false, msg: 'Error al anular la venta' };
        }
    };
};

export const startUpdateVenta = (ventaId, ventaData) => {
    return async (dispatch, getState) => {
        try {
            const resp = await fetchConToken(`ventas/${ventaId}`, ventaData, 'PUT');
            const body = await resp.json();

            if (!body.ok) {
                throw new Error(body.msg);
            }

            if (ventaData.metodoPago === 'Monedero' || body.venta?.metodoPago === 'Monedero') {
                const usuarioId = ventaData.usuario || body.venta?.usuario?._id || body.venta?.usuario;
                const empresaId = ventaData.empresa || body.venta?.empresa?._id || body.venta?.empresa;
                if (usuarioId && empresaId) {
                    const respUsuario = await fetchConToken(`usuarios/usuario`, { usuario: usuarioId, empresa: empresaId }, 'POST');
                    const bodyUsuario = await respUsuario.json();
                    if (bodyUsuario.usuario) {
                        dispatch(refreshUsuario(usuarioId, bodyUsuario.usuario));
                    }
                }
            }

            return { ok: true, venta: body.venta, ...(body.cita && { cita: body.cita }) };
        } catch (error) {
            console.error('Error al actualizar la venta:', error);
            return { ok: false, error };
        }
    }
};
